import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../services/api';
import { toast } from 'react-toastify';

const passwordRules = [
  { test: (p) => p.length >= 12, label: '12 caractères minimum' },
  { test: (p) => /[A-Z]/.test(p), label: '1 majuscule' },
  { test: (p) => /[a-z]/.test(p), label: '1 minuscule' },
  { test: (p) => /[0-9]/.test(p), label: '1 chiffre' },
  { test: (p) => /[@$!%*?&.#^()_+\-=]/.test(p), label: '1 caractère spécial (@$!%*?&...)' },
];

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const allRulesPassed = passwordRules.every((rule) => rule.test(formData.password));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await registerUser(formData);
      toast.success('Inscription réussie ! Vous pouvez maintenant vous connecter.');
      navigate('/login');
    } catch (err) {
      if (err.response) {
        const { message, errors } = err.response.data;
        if (errors) {
          errors.forEach((msg) => toast.error(msg));
        } else {
          toast.error(message || 'Erreur lors de l\'inscription');
        }
      } else {
        toast.error('Une erreur est survenue. Veuillez réessayer.');
      }
    }
  };

  return (
    <div className="flex justify-center items-center h-screen">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md w-80">
        <h2 className="text-2xl font-bold mb-4 text-center">Inscription</h2>
        <input
          type="text"
          name="username"
          placeholder="Nom d'utilisateur"
          value={formData.username}
          onChange={handleChange}
          className="border border-gray-300 p-2 w-full mb-4"
        />
        <input
          type="email"
          name="email"
          placeholder="Adresse email"
          value={formData.email}
          onChange={handleChange}
          className="border border-gray-300 p-2 w-full mb-4"
        />
        <input
          type="password"
          name="password"
          placeholder="Mot de passe"
          value={formData.password}
          onChange={handleChange}
          className="border border-gray-300 p-2 w-full mb-2"
        />
        {formData.password && (
          <ul className="text-sm mb-4 space-y-1">
            {passwordRules.map((rule, i) => (
              <li key={i} className={rule.test(formData.password) ? 'text-green-600' : 'text-red-500'}>
                {rule.test(formData.password) ? '✓' : '✗'} {rule.label}
              </li>
            ))}
          </ul>
        )}
        {!formData.password && <div className="mb-4" />}
        <button
          type="submit"
          disabled={!allRulesPassed}
          className={`p-2 w-full rounded text-white ${allRulesPassed ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-400 cursor-not-allowed'}`}
        >
          S'inscrire
        </button>
      </form>
    </div>
  );
};

export default Register;
